export default "__VITE_ASSET__CNCkINiB__"